import { Group, Opportunity } from "@entities";
import { extender } from "@shared/backend/class-extender";
import HyperEntity from "@shared/backend/hyper-entity.decorator";
import { Fields, Relations } from "remult";
import { GroupOpportunityEntityConfig } from "./config";
import { GroupOpportunityFilters } from "./filters";
import { GroupOpportunityMethods } from "./methods";

@HyperEntity("group-opportunity", GroupOpportunityEntityConfig)
export class GroupOpportunity extends extender(
  GroupOpportunityFilters,
  GroupOpportunityMethods,
) {
  @Fields.string({ dbName: "group_id" })
  groupId = "";

  @Fields.string({ dbName: "opportunity_id" })
  opportunityId = "";

  @Relations.toOne<GroupOpportunity, Opportunity>(
    () => Opportunity,
    "opportunityId",
  )
  opportunity?: Opportunity;

  @Relations.toOne<GroupOpportunity, Group>(() => Group, "groupId")
  group?: Group;

  @Fields.createdAt({
    dbName: "created_at",
  })
  createdAt = new Date();

  @Fields.updatedAt({ dbName: "updated_at" })
  updatedAt = new Date();

  @Fields.boolean({ dbName: "internal_arrived", defaultValue: () => false })
  internalArrived = false;
}
